var map = {
	"./credit-img-01.png": "e99f",
	"./credit-img-02.png": "df47",
	"./credit-img-03.png": "da66",
	"./credit-img-04.png": "19be",
	"./credit-img-05.png": "f95a",
	"./credit-img-06.png": "03e4",
	"./credit-img-07.png": "f561",
	"./credit-img-08.png": "8a88",
	"./credit-img-09.png": "2eeb",
	"./logo_arxit.png": "956c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "63fe";